import { GET_ERROR_HANDLER_SUCCESS } from "../../constants/errorsHandlerConstants";

const errorsHandlerAction = (errors) => (dispatch) => {
  return dispatch({
    type: GET_ERROR_HANDLER_SUCCESS,
    payload: errors,
  });
};

export default errorsHandlerAction;
